import React from "react";
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
  render() {
    const SupplyDebtInput = this.props.SupplyDebtInput;
    const SupplyDebtDetails = this.props.SupplyDebtDetails;
    const SearchData = this.props.SearchData;
    
    const totalLastMonthCrop = SupplyDebtDetails.reduce((sum, row) => sum + Number(row.lastMonthCropWeight), 0);
    const totalThisTotal = SupplyDebtDetails.reduce((sum, row) => sum + Number(row.thisTotal), 0);
    const totalDebtAmount = SupplyDebtDetails.reduce((sum, row) => sum + Number(row.debtAmount), 0);
    const totalLoanTotal = SupplyDebtDetails.reduce((sum, row) => sum + Number(row.loanTotal), 0);

    const tableStyles = {
      table: {
        border: '1px solid #ccc',
        borderCollapse: 'collapse'
      },
      tableCell: {
        padding: '6px' 
      },
      routeNameCell: {
        width: '100px', 
        padding: '6px',
        whiteSpace: 'nowrap'
      },
      numericCell: {
        paddingRight: '30px',
        textAlign: 'right'
      }
    };

    return (
      <div>
        <h3><center><u>Supply Debt List Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{SearchData.groupName} - {SearchData.factoryName}</center></h4>
        <h4><center>Route -{SupplyDebtInput.routeName}</center></h4>
        <h4><center>{SupplyDebtInput.year}/{SupplyDebtInput.month}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer style={{ marginLeft: '5px', paddingRight:'5px'}} spacing={1}>
              <Table aria-label="caption table" style={tableStyles.table} size="small">
                <TableHead>
                  <TableRow style={{ borderBottom: '1px solid #ccc' }}>
                    <TableCell align={'left'} style={tableStyles.routeNameCell}>Route Name</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Registration Number</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Customer Name</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Last Month Crop (KG)</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Todate Crop (KG)</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Last Month Debt (Rs.)</TableCell>
                    <TableCell align={'left'} style={tableStyles.tableCell}>Loan Balance (Rs.)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {SupplyDebtDetails.map((data, index) => (
                    <TableRow key={index} style={{ height: '36px' }}>
                      <TableCell align={'left'} component="th" scope="row" style={{ ...tableStyles.routeNameCell, borderBottom: "none" }}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ ...tableStyles.tableCell, borderBottom: "none" }}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ ...tableStyles.routeNameCell, borderBottom: "none" }}>
                        {data.name}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, borderBottom: "none" }}>
                        {Number(data.lastMonthCropWeight).toLocaleString()}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, borderBottom: "none" }}>
                        {Number(data.thisTotal).toLocaleString()}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, borderBottom: "none" }}>
                        {Number(data.debtAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, borderBottom: "none" }}>
                        {Number(data.loanTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}
                 
                  <TableRow style={{ borderTop: '1px solid #ccc' }}>
                    <TableCell colSpan={3} align={'left'} component="th" scope="row" style={{ ...tableStyles.tableCell, fontWeight: "bold", borderBottom: "none" }}>
                      Total
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, fontWeight: "bold", borderBottom: "none" }}>
                      {totalLastMonthCrop.toLocaleString()}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, fontWeight: "bold", borderBottom: "none" }}>
                      {totalThisTotal.toLocaleString()}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, fontWeight: "bold", borderBottom: "none" }}>
                      {totalDebtAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ ...tableStyles.tableCell, ...tableStyles.numericCell, fontWeight: "bold", borderBottom: "none" }}>
                      {totalLoanTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
        <div>&nbsp;</div>
        <h3><center>***** End of List *****</center></h3>
      </div>
    );
  }
}